/**
 * Sticky Tabs Block
 *
 * UI for handling the logic and rendering for the animations and class toggling for the tabs
 */

const $ = require( 'jquery' );
const _throttled = require( '../_debounce' );

var StickyTabs = function(el){

  //setup some variables
  this.$el  = $(el);
  this.$animationEls   = this.$el.find( '.media--animation' );
  this.$screenshotEls  = this.$el.find( '.media--screenshots' );
  this.$tabs      = this.$el.find( '.itbl-c-sticky-tabs__tab' );
  this.$linksWrapper  = this.$el.find( '.itbl-c-sticky-tabs__links-inner' );
  this.$links      = this.$el.find( '.itbl-c-sticky_tabs__link' );
  this.$scrollToLinks  = this.$el.find( '.js-scroll-to-target' );
  this.$nodes      = this.$el.find( '.itbl-b-bg-node' );

  this.scrollCheck   = false;
  this.hasIntersectionObserver = ('IntersectionObserver' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype);

  this.AnimationStates = {};
  this.screenshots = {};

  this.init();
};

StickyTabs.prototype.init = function(){

  //get all animations and initialize them
  this.calcStickyPosition();
  this.initAnimations();
  this.initTab__intersectionObserver();
  this.initParallax__intersectionObserver();
  this.events();

};

StickyTabs.prototype.events = function(){
  this.$links.on('click', this.event__handleScrollToTab.bind(this) );
};

StickyTabs.prototype.calcStickyPosition = function(){

  if( this.$linksWrapper.length === 0 ){
    return;
  }


  this.$linksWrapper.css( 'top', `calc(50% - ${this.$linksWrapper.outerHeight()/2}px)` );

};

StickyTabs.prototype.initAnimations = function(){

  if(this.$el.hasClass('disbale-animations')) {
    return;
  }

  //iterate over each animate element to initialize the animation block
  this.$animationEls.each( (index, el)=>{
    const $el       = $(el);
    const name       = ( typeof $el.data( 'name' ) !== 'undefined' ) ? $el.data( 'name' ) : null ;
    const animationPath  = ( typeof $el.data( 'animation-path' ) !== 'undefined' ) ? $el.data( 'animation-path' ) : null ;

    //create a state of animations with the initialized Obj
    this.AnimationStates[name] = {
      isPlaying   : false,
      instance  : lottie.loadAnimation({
        container: el, // the dom element
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: name,
        path: animationPath, // the animation data
        rendererSettings: {
          className: 'itbl-c-sticky-tabs__anim',
          progressiveLoad: true, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
          hideOnTransparent: true, //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
        }
      })
    };

  } );
};

StickyTabs.prototype.initTab__intersectionObserver = function(){

  //if intersection observer is not supported add all active-classes
  if( !this.hasIntersectionObserver ){
    this.$tabs.addClass( 'tab-is-visible' );
    this.$nodes.addClass( 'node-is-active' );
    return;

  }

  //this function will help with hiding and showing each tab when in view
  //setup the tiniest window for the rootmargin
  const config = {
    rootMargin: '-48% 0px -48% 0px',
  };
  let lastScrollTop = 0;
  let goingDown;
  let goingUp;

  const observer = new IntersectionObserver((entries) => {

    let scrollTop = $(window).scrollTop();

    goingDown   = scrollTop < lastScrollTop;
    goingUp    = !goingDown;

    entries.forEach(entry => {

      //create get target, and check is this is a lottie animation
      var $target     = $(entry.target);
      var $hasAnimation  = $target.find( '.media--animation' );
      var $hasScreenshot  = $target.find( '.media--screenshots' );
      var $circle      = $hasScreenshot.find( 'svg circle.itbl-b-bg-node' );
      var id        = $target.attr('id');
      var showInit    = $target.attr('data-show-init');
      var $activeLink    = this.$linksWrapper.find( `a[href^="#${id}"]` );

      // Initially show first tab, if set
      if(showInit) {
        if(!this.$el.hasClass('disable-animations')) {
          //make the tab visible
          $target.addClass( 'tab-is-visible' );
        }

        //toggle the classes for the links
        $activeLink.addClass('link-is-active');

        // Hide it after scroll
        $(entry.target).removeAttr('data-show-init');
      }
      else {
      
        //check if this target has intersected
        if (entry.isIntersecting || entry.intersectionRatio > 0.2 ) {

          //check if this is a lottie animation
          if( $hasAnimation.length ){

            const name   = ( typeof $hasAnimation.data( 'name' ) !== 'undefined' ) ? $hasAnimation.data( 'name' ) : null ;
            //go to the beginning of animation and play

            //speed up the animations a tiny bit
            lottie.setSpeed( 1.3 );
            //play lottie animation by locating it from the animation state
            this.AnimationStates[name].instance.goToAndPlay( 0, true );

          }

          //check if this is a screenshot
          if( $hasScreenshot.length ){

            $circle.addClass( 'node-is-active' );

          }

          if(!this.$el.hasClass('disable-animations')) {
            //make the tab visible
            $target.addClass( 'tab-is-visible' );
          }

          //toggle the classes for the links
          this.$links.removeClass( 'link-is-active' );
          $activeLink.addClass('link-is-active');


        }else{


          if( goingUp ){

            //needed to separate this condition because we want the last item to always show when user scrolls past this block
            if(!this.$tabs.last().is($target) ){

              if(!this.$el.hasClass('disable-animations')) {
                $target.removeClass( 'tab-is-visible' );
              }
              $activeLink.removeClass('link-is-active');
            }

          }else{
            //if this element is not intersecting remove the visible classes if has any
            if(!this.$el.hasClass('disable-animations')) {
              $target.removeClass( 'tab-is-visible' );
            }

            $activeLink.removeClass('link-is-active');

            //remove the active node
            $circle.removeClass( 'node-is-active' );

          }

        }
      }

    lastScrollTop = scrollTop;

    });
  }, config);

  this.$tabs.get().forEach(tab => {
		observer.observe(tab);
	});

};

StickyTabs.prototype.event__handleScrollToTab = function(event){

  let el, speed;

  if( this.scrollCheck === false ) {

    this.scrollCheck = true;
  }

  if( typeof event.target !== 'undefined'){

    event.preventDefault();

    speed   = 700;
    el     = $( event.currentTarget.getAttribute('href') );
  }else{
    speed   = 300;
    el     = event;
  }

  var elOffset = el.offset().top;
  var elHeight = el.outerHeight();
  var windowHeight = window.outerHeight;
  var offset;

  if (elHeight < windowHeight) {
    offset = elOffset - ( (windowHeight- elHeight)  / 2);
  }
  else {
    offset = elOffset;
  }


  //@todo - can add a callback to cancel the dot progress for the scrolling. this behavior would match slicks jump when dots are clicks


  this.animationScroll = $('html, body').animate(
    {scrollTop:offset},
    speed
    , ()=>{
      this.scrollCheck = false;
    });

};

StickyTabs.prototype.createThreshold = function () {

  const threshold = [];
  for (let i = 0; i <= 1.0; i += 0.01) {
    threshold.push(i);
  }

  return threshold;
};

StickyTabs.prototype.initParallax__intersectionObserver = function(){

  //if there's no intersection observer, then do nothing
  if( !this.hasIntersectionObserver ){
    return;
  }

  let observer;
  let observerOptions = {
    root: null,
    rootMargin: '45% 0px -50% 0px',
    threshold: this.createThreshold()
  };
  let yInitialOffset = 75;


  //callback for intersection observer
  const intersectionCallback = (entries, observer) => {
    entries.forEach(entry => {

      let box     = entry.target;
      let parallax   = $(box).find('.itbl-c-sticky-tabs__parallax');

      //tween the animation
      TweenLite
        .to(
          parallax,
          0,
          {
            //uses intersection ratio to determine the value to translate
            //the last number is an offset used to weight of the translate
            y : yInitialOffset + ( -1 * (entry.intersectionRatio * 165) ),
            ease : Power2.easeInOut
          }

        );
    });
  };

  observer = new IntersectionObserver(intersectionCallback, observerOptions);

  this.$screenshotEls.get().forEach(screenshot => {
    observer.observe(screenshot);
  });



};


$(document).ready(function(){
  $('.itbl-c-sticky-tabs').each(function(){
    new StickyTabs(this);
  });

});
